var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_627_12485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00537 1.19348C5.36492 1.19534 3.79218 1.84784 2.6322 3.00782C1.47223 4.1678 0.819732 5.74053 0.817871 7.38099C0.817871 12.6755 6.44287 16.6763 6.68193 16.8451C6.77774 16.9089 6.89027 16.9429 7.00537 16.9429C7.12047 16.9429 7.233 16.9089 7.32881 16.8451C7.56787 16.6763 13.1929 12.6755 13.1929 7.38099C13.191 5.74053 12.5385 4.1678 11.3785 3.00782C10.2186 1.84784 8.64583 1.19534 7.00537 1.19348ZM7.00537 5.13099C7.45038 5.13099 7.88539 5.26295 8.2554 5.51018C8.62541 5.75742 8.9138 6.10882 9.0841 6.51995C9.2544 6.93109 9.29895 7.38349 9.21214 7.81995C9.12532 8.2564 8.91103 8.65732 8.59636 8.97199C8.28169 9.28665 7.88078 9.50095 7.44432 9.58776C7.00787 9.67458 6.55547 9.63002 6.14433 9.45973C5.7332 9.28943 5.3818 9.00104 5.13456 8.63103C4.88733 8.26102 4.75537 7.826 4.75537 7.38099C4.75537 6.78425 4.99242 6.21196 5.41438 5.79C5.83634 5.36804 6.40863 5.13099 7.00537 5.13099Z",
    fill: "#FB8041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_627_12485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 16.875,
    fill: "white",
    transform: "translate(0.25 0.378906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.03c4b1e72711753938565414439527f6.svg";
export { ForwardRef as ReactComponent };